import { Modal } from 'components/Modal/Modal';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { useMutation, useQueryClient } from 'react-query';
import showToast from 'components/Toast/Toast';
import { useNavigate, useParams } from 'react-router-dom';
import { FC } from 'react';
import { deleteKey } from './utils';

interface DeleteKeyProps {
  navigateTo?: string;
}

const DeleteKey: FC<DeleteKeyProps> = ({ navigateTo }) => {
  const { client_id, name } = useParams<{ client_id: string; name: string }>();

  const navigate = useNavigate();

  const onClose = () => navigate(navigateTo ?? '..', { replace: true });

  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(deleteKey, {
    onSuccess: () => {
      showToast.confirmation({
        title: 'API key deleted',
        message: `${name}`,
      });
      queryClient.refetchQueries('user-settings-api-keys');
      onClose();
    },
  });

  return (
    <Modal isVisible={true} close={onClose} className="w-full max-w-[624px]">
      <div className="p-8">
        <div>
          <h1 className="text-2xl font-bold text-white">
            Are you sure you want to delete this key?
          </h1>
          <p className="mt-2 text-base font-bold text-neutral-500">
            This action is irreversible and will immediately revoke access to
            any services or resources associated with the key.
          </p>
        </div>
        <div className="mt-8 flex gap-5">
          <GraniteButton variant="secondary" size="large" onClick={onClose}>
            Cancel
          </GraniteButton>
          <GraniteButton
            size="large"
            variant="destructive"
            disabled={isLoading}
            onClick={() => mutate(client_id as string)}
          >
            Yes, delete key
          </GraniteButton>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteKey;
